module.exports = __webpack_public_path__ + "static/media/empty-favorites-placeholder-vault.4b9882a7.svg";